import { ListNotificationSegments, ListNotificationSegmentsVariables } from './__generated__/ListNotificationSegments'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListNotificationSegments($input: ListNotificationSegmentInputV2!) {
    listNotificationSegments: listNotificationSegmentsV2(input: $input) {
      nextCursor
      notificationSegments {
        id
        title
        isDynamic
        dynamicUrl
      }
    }
  }
`

export const useListNotificationSegments = (variables: ListNotificationSegmentsVariables) => {
  return useQuery<ListNotificationSegments, ListNotificationSegmentsVariables>(QUERY, {
    variables
  })
}

useListNotificationSegments.QUERY = QUERY
